<template>
  <div>
    <v-bottom-sheet v-model="loginSelector" inset persistent>
      <v-sheet class="text-center rounded-t-xl login-selector" x-v-click-outside="cancel()">
        <div class="py-3">
          {{ $t("login_as") }}
        </div>

        <div>
          <v-btn color="secondary" class="secondaryText--text" @click="login(true)">
            {{ $t("member") }}
          </v-btn>
        </div>

        <div>
          <v-btn color="secondary" class="secondaryText--text" @click="login(false)">
            {{ $t("guest") }}
          </v-btn>
        </div>

        <div>
          <v-btn color="warning" class="warningText--text" @click="cancel()">
            {{ $t("cancel") }}
          </v-btn>
        </div>
      </v-sheet>
    </v-bottom-sheet>

    <GuestLoginDialog ref="guestLoginDialog"></GuestLoginDialog>
  </div>
</template>

<script>
import GuestLoginDialog from "@/dialogs/GuestLoginDialog";

export default {
  components: {
    GuestLoginDialog,
  },

  data() {
    return {
      loginSelector: this.show,
    };
  },

  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },

  watch: {
    show() {
      this.loginSelector = this.show;
    },
  },

  computed: {},

  methods: {
    cancel() {
      this.$emit("cancel");
    },

    login(loginAsMember) {
      if (
        this.$store.state.order.orderType == this.$store.state.OT_DINEIN &&
        this.$store.getters.notAskDineInGuestPhone
      ) {
        this.$emit("completed");
      } else {
        if (loginAsMember) {
          if (this.$store.state.member == null) {
            this.$root.memberLoginDialog().then(logined => {
              if (logined) {
                this.$emit("completed");
              }
            });
          } else {
            this.updateOrderLogin(loginAsMember);
            this.$emit("completed");
          }
        } else {
          this.$refs.guestLoginDialog.open().then(logined => {
            if (logined) {
              this.$emit("completed");
            }
          });
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.login-selector {
  overflow: auto;
  max-height: 90vh;

  padding: 16px;
  .v-btn {
    //padding: 16px;
    margin: 8px;
    width: 90%;
  }
}
</style>
